import { TranslationObject } from '../../i18n/translation';

const translations: TranslationObject = {
  ok: { id: 'informationDialog.ok', nb: 'Ok', en: 'Ok' },
};

export default translations;
